import { render, staticRenderFns } from "./success-dialog.vue?vue&type=template&id=58670d5a&scoped=true&"
import script from "./success-dialog.vue?vue&type=script&lang=js&"
export * from "./success-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58670d5a",
  null
  
)

export default component.exports